import React from 'react';
import { FadeInUp } from './FadeInUp';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function TwoPathsClose() {
  return <section className="py-20 px-6 bg-white" data-id="element-340">
      <div className="max-w-5xl mx-auto" data-id="element-341">
        <FadeInUp data-id="element-342">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-16 text-center text-deep-green" data-id="element-343">
            Tienes dos caminos
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-344">
          {/* Left Path */}
          <FadeInUp delay={0.1} data-id="element-345">
            <div className="bg-gray-50 border border-gray-200 p-8 md:p-10 rounded-3xl h-full opacity-80 hover:opacity-100 transition-opacity" data-id="element-346">
              <div className="w-14 h-14 bg-red-100 rounded-2xl flex items-center justify-center mb-8 text-red-500" data-id="element-347">
                <XCircle className="w-7 h-7" data-id="element-348" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-charcoal mb-6" data-id="element-349">
                Seguir como estás
              </h3>
              <ul className="space-y-4" data-id="element-350">
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-351">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-352" />
                  <span data-id="element-353">Seguir hinchada cada noche</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-354">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-355" />
                  <span data-id="element-356">Probar otra dieta que no funciona</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-357">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-358" />
                  <span data-id="element-359">Gastar $200+ en cosas que no dan resultado</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-360">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-361" />
                  <span data-id="element-362">Sentirte frustrada con tu cuerpo</span>
                </li>
              </ul>
            </div>
          </FadeInUp>

          {/* Right Path */}
          <FadeInUp delay={0.2} data-id="element-363">
            <div className="bg-cream border-2 border-gold/30 p-8 md:p-10 rounded-3xl h-full shadow-xl relative overflow-hidden group" data-id="element-364">
              <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-365"></div>
              <div className="relative z-10" data-id="element-366">
                <div className="w-14 h-14 bg-sage/20 rounded-2xl flex items-center justify-center mb-8 text-sage shadow-sm" data-id="element-367">
                  <CheckCircle2 className="w-7 h-7" data-id="element-368" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-deep-green mb-6" data-id="element-369">
                  Empezar hoy por $6.36
                </h3>
                <ul className="space-y-4" data-id="element-370">
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-371">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-372" />
                    <span data-id="element-373">Un plan claro de 7 días</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-374">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-375" />
                    <span data-id="element-376">Ingredientes que ya tienes en casa</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-377">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-378" />
                    <span data-id="element-379">Resultados desde los primeros días</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-380">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-381" />
                    <span data-id="element-382">Garantía de 7 días sin riesgo</span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}